import MigrationModal from './migration-modal';

export default MigrationModal;
